<template>
	<div>
		<v-container fluid pa-0>
			<v-card elevation="0">
				<v-container fluid grid-list-xl class="toolbar-container">
					<v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
						<v-toolbar color="grey lighten-3" elevation="1">
							<bc-btn-back></bc-btn-back>
							<v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
							<v-spacer></v-spacer>
							<bc-btn-add v-if="hasPerm('people.create')" @invoke-method="invokeMethod($event)" action="openPersonForm"></bc-btn-add>
							<bc-btn-refresh @invoke-method="dbGetPeople(true)"></bc-btn-refresh>
							<bc-search-menu :params="axiosParams" @open="openSearch()">
								<v-list>
									<v-list-tile class="mb-3">
										<bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
									</v-list-tile>
									<v-list-tile class="mb-3">
										<bc-autocomplete
											v-model="filter.company_id"
											:label="$t('lang.company')"
											:items="company_options"
											item-value="company_id"
											item-text="company"
											prepend-icon="business"
											:hide-details="true"
											clearable
											@click:clear="filterClearInput()"
										></bc-autocomplete>
									</v-list-tile>
									<v-list-tile class="mb-3" v-if="isInternalUser() || hasLoginType(['d_acct_mgr', 'distributor'])">
										<bc-autocomplete
											v-model="filter.login_type"
											:label="$t('lang.login_type')"
											:items="login_types"
											item-value="login_type_id"
											item-text="login_type"
											prepend-icon="manage_accounts"
											:hide-details="true"
											clearable
											@click:clear="filterClearInput()"
											v-pt="[{ selector: '.v-subheader', classes: ['fs-14', 'fw-bold', 'text-uppercase'] }]"
										>
											<template v-slot:item="data">
												<template>
													<v-list-tile-content class="ml-4 no-stripe">
														<v-list-tile-title>{{ $t(`lang.${data.item.login_type}`) }}</v-list-tile-title>
													</v-list-tile-content>
												</template>
											</template>
											<template slot="selection" slot-scope="data">
												{{ $t(`lang.${data.item.login_type}`) }}
											</template>
										</bc-autocomplete>
									</v-list-tile>
									<v-list-tile class="mb-3">
										<bc-select
											v-model="filter.has_user_account"
											:label="$t('lang.user_account')"
											:items="[
												{ name: $t('lang.yes'), value: '1' },
												{ name: $t('lang.no'), value: '0' },
											]"
											item-value="value"
											item-text="name"
											prepend-icon="account_box"
											:hide-details="true"
											clearable
											@click:clear="filterClearInput()"
										></bc-select>
									</v-list-tile>
								</v-list>
							</bc-search-menu>
							<bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
						</v-toolbar>
					</v-layout>
				</v-container>
				<bc-circle-loader v-if="loading"></bc-circle-loader>
				<v-card-text v-else :class="$bp.smallScreen ? 'pa-0' : null">
					<v-data-table :headers="headers" :items="people" :no-data-text="$t('lang.no_results_matching')" hide-actions>
						<template slot="items" slot-scope="props">
							<tr class="clickable" @mouseup.left="openPersonForm(props.item)">
								<td><img :src="props.item.photo" @error="imageLoadError" style="max-width: 50px; max-height: 50px" /></td>
								<td>{{ props.item.first_name }} {{ props.item.last_name }}</td>
								<td>{{ props.item.slug ? $t(`lang.${props.item.slug}`) : null }}</td>
								<td class="text-center">{{ props.item.last_login }}</td>
								<td>
									<v-layout justify-center>
										<v-chip label text-color="white" :color="props.item.status_class">
											<span
												><v-icon>{{ props.item.has_user_account_icon }}</v-icon></span
											>
										</v-chip>
									</v-layout>
								</td>
							</tr>
						</template>
					</v-data-table>
					<bc-pagination :page="page" :params="axiosParams" name="people"></bc-pagination>
				</v-card-text>
			</v-card>

			<bc-dialog :value="createNewUserDialog" :max-width="user_account == 1 ? '975' : '600'">
				<v-card>
					<v-card-title>
						<span class="headline">{{
							!isManual ? $t("lang.invite_user") : user_account == 0 ? $t("lang.create_new_person") : $t("lang.create_new_user")
						}}</span>
						<v-spacer></v-spacer>
						<bc-btn-dialog-close
							@invoke-method="invokeMethod($event)"
							:dialog-status="createNewUserDialog"
							dialog-model="createNewUserDialog"
						></bc-btn-dialog-close>
					</v-card-title>
					<v-card-text>
						<v-form ref="newUserForm">
							<v-container grid-list-form>
								<v-layout v-if="!isManual" row wrap>
									<v-flex xs12 sm6>
										<v-text-field
											v-focus="createNewUserDialog && invite_user.first_name == ''"
											v-model="invite_user.first_name"
											:label="`${$t('lang.first_name')} *`"
											:counter="showCounter(invite_user.first_name, 'user.first_name')"
											:rules="ifValid('person.users.first_name')"
										></v-text-field>
									</v-flex>
									<v-flex xs12 sm6>
										<v-text-field
											v-model="invite_user.last_name"
											:label="`${$t('lang.first_name')} *`"
											:counter="showCounter(invite_user.first_name, 'user.first_name')"
											:rules="ifValid('person.users.first_name')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<bc-phone-input
											ref="user_phone_input"
											:update-object="invite_user"
											input-label="mobile_phone"
											:rules="ifValid('person.users.phone_number')"
										></bc-phone-input>
									</v-flex>
									<v-flex xs12 v-if="isInternalUser() || hasLoginType(['d_acct_mgr', 'distributor'])">
										<bc-autocomplete
											v-model="invite_user.login_type_id"
											:label="`${$t('lang.login_type')} *`"
											:items="login_types"
											item-value="login_type_id"
											item-text="login_type"
											:rules="ifValid('person.users.login_type_id')"
										>
											<template v-slot:item="data">
												<template v-if="typeof data.item !== 'object'">
													<v-list-tile-content v-text="data.item"></v-list-tile-content>
												</template>
												<template v-else>
													<v-list-tile-content>
														<v-list-tile-title>{{ $t(`lang.${data.item.login_type}`) }}</v-list-tile-title>
													</v-list-tile-content>
												</template>
											</template>
											<template slot="selection" slot-scope="data">
												{{ $t(`lang.${data.item.login_type}`) }}
											</template>
										</bc-autocomplete>
									</v-flex>
									<v-flex xs12>
										<bc-autocomplete
											v-model="invite_user.company_id"
											:label="`${$t('lang.select_a_company')} *`"
											:items="company_options"
											item-text="company"
											item-value="company_id"
											:rules="ifValid('person.users.company_id')"
										></bc-autocomplete>
									</v-flex>
									<v-flex xs6>
										<v-switch
											v-model="invite_user.owner"
											:label="invite_user.owner == 1 ? $t('lang.is_owner_yes') : $t('lang.is_owner_no')"
											:true-value="1"
											:false-value="0"
											ripple
										></v-switch>
									</v-flex>
								</v-layout>
								<!-- This is the newManual manual form -->
								<v-layout v-if="isManual" row wrap>
									<v-flex :sm6="user_account == 1" :xs12="user_account == 0" pa-0 align-self-start>
										<v-layout row wrap>
											<v-flex xs12 sm6>
												<v-text-field
													v-focus="createNewUserDialog && person.first_name == ''"
													v-model="person.first_name"
													:label="`${$t('lang.first_name')} *`"
													:counter="showCounter(person.first_name, 'person.first_name')"
													:rules="ifValid('person.first_name')"
												></v-text-field>
											</v-flex>
											<v-flex xs12 sm6>
												<v-text-field
													v-model="person.last_name"
													:label="`${$t('lang.last_name')} *`"
													:counter="showCounter(person.last_name, 'person.last_name')"
													:rules="ifValid('person.last_name')"
												></v-text-field>
											</v-flex>
											<v-flex xs12>
												<bc-phone-input
													ref="person_phone_input"
													:update-object="person.entity_phones[0]"
													input-label="mobile_phone"
													:rules="ifValid('person.entity_phones.phone_number')"
												></bc-phone-input>
											</v-flex>
											<v-flex xs12>
												<v-text-field
													v-model="person.entity_emails[0].email_address"
													:label="`${$t('lang.email_address')} *`"
													:counter="showCounter(person.email_address, 'person.email_address')"
													:rules="ifValid('person.entity_emails.email_address')"
												></v-text-field>
											</v-flex>
											<v-flex xs12 sm6>
												<v-text-field
													v-model="person.nick_name"
													:label="$t('lang.nick_name')"
													:counter="showCounter(person.nick_name, 'person.nick_name')"
													:rules="ifValid('person.nick_name')"
												></v-text-field>
											</v-flex>
											<v-flex xs12 sm6>
												<v-text-field
													v-model="person.job_title"
													:label="`${$t('lang.job_title')}`"
													:counter="showCounter(person.job_title, 'person.job_title')"
													:rules="ifValid('person.job_title')"
												></v-text-field>
											</v-flex>
											<v-flex :class="user_account == 1 && $bp.smAndUp ? 'xs12' : 'xs6'">
												<v-switch
													v-model="user_account"
													:label="user_account == 1 ? $t('lang.create_user_account_yes') : $t('lang.create_user_account_no')"
													:true-value="1"
													:false-value="0"
													ripple
													:class="user_account == 1 && $bp.smAndUp ? 'pt-3' : null"
												></v-switch>
											</v-flex>
										</v-layout>
									</v-flex>
									<v-flex xs12 sm6 pa-0 align-self-start v-if="user_account == 1">
										<v-layout row wrap>
											<v-flex xs12>
												<v-text-field
													v-model="user.username"
													:label="`${$t('lang.username')} *`"
													:counter="showCounter(user.username, 'user.username')"
													:rules="ifValid('person.users.username')"
													@change="dbcheckUserNameAvail(user.username)"
												>
													<template slot="append-outer">
														<bc-tooltip>
															<template slot="activator">
																<v-icon :color="availableUserName.exists ? 'error' : 'success'">{{
																	availableUserName.exists ? "close" : "check"
																}}</v-icon>
															</template>
															{{ availableUserName.exists ? $t("lang.username_not_avail") : $t("lang.username_avail") }}
														</bc-tooltip>
													</template>
												</v-text-field>
											</v-flex>
											<v-flex xs12>
												<bc-password-input
													v-model="user.password"
													:label="`${$t('lang.password')} *`"
													:counter="showCounter(user.password, 'user.password')"
													:rules="ifValid('person.users.password')"
												></bc-password-input>
											</v-flex>
											<v-flex xs12>
												<bc-password-input
													v-model="confirm_password"
													:label="`${$t('lang.confirm_password')} *`"
													:rules="ifValid('person.users.confirm_password')"
												></bc-password-input>
											</v-flex>
											<v-flex xs12 v-if="isInternalUser() || hasLoginType(['d_acct_mgr', 'distributor'])">
												<bc-autocomplete
													v-model="user.login_type_id"
													:label="`${$t('lang.login_type')} *`"
													:items="returnFilteredLoginTypes"
													item-value="login_type_id"
													item-text="login_type"
													:rules="ifValid('person.users.login_type_id')"
													@change="loginTypeChanged(user.login_type_id)"
													v-pt="[{ selector: '.v-subheader', classes: ['fs-14', 'fw-bold', 'text-uppercase'] }]"
												>
													<template v-slot:item="data">
														<template>
															<v-list-tile-content class="ml-4 no-stripe">
																<v-list-tile-title>{{ $t(`lang.${data.item.login_type}`) }}</v-list-tile-title>
															</v-list-tile-content>
														</template>
													</template>
													<template slot="selection" slot-scope="data">
														{{ $t(`lang.${data.item.login_type}`) }}
													</template>
												</bc-autocomplete>
											</v-flex>
											<v-flex
												xs12
												v-if="
													personHasLoginType(user, [
														'csr',
														'producer',
														'dispatcher',
														'technician',
														'driver',
														'dispenser_mgr',
														'customer',
														'customer_readonly',
														'v_acct_mgr',
														'vendor',
													])
												"
											>
												<bc-autocomplete
													v-model="user.company_id"
													:label="`${$t('lang.select_a_company')} *`"
													:items="
														personHasLoginType(user, [
															'csr',
															'producer',
															'dispatcher',
															'technician',
															'driver',
															'dispenser_mgr',
															'customer',
															'customer_readonly',
														])
															? customer_options
															: vendor_options
													"
													item-text="company"
													item-value="company_id"
													:rules="ifValid('person.users.company_id')"
												></bc-autocomplete>
											</v-flex>
											<v-flex xs12 v-else-if="personHasLoginType(user, ['d_acct_mgr', 'distributor'])">
												<bc-autocomplete
													v-model="user.company_id"
													:label="`${$t('lang.select_a_company')} *`"
													:items="distributor_options"
													item-text="company"
													item-value="company_id"
													:rules="ifValid('person.users.company_id')"
												></bc-autocomplete>
											</v-flex>
											<v-flex
												xs12
												sm6
												v-if="
													hasLoginType([
														'csr',
														'producer',
														'dispatcher',
														'technician',
														'driver',
														'dispenser_mgr',
														'd_acct_mgr',
														'v_acct_mgr',
														'customer',
														'customer_readonly',
														'vendor',
														'distributor',
													])
												"
											>
												<v-switch
													v-model="user.owner"
													:label="user.owner == 1 ? $t('lang.is_owner_yes') : $t('lang.is_owner_no')"
													true-value="1"
													false-value="0"
													ripple
													:class="user_account == 1 && $bp.smAndUp ? 'pt-3' : null"
												></v-switch>
											</v-flex>
										</v-layout>
									</v-flex>
								</v-layout>
							</v-container>
						</v-form>
					</v-card-text>
					<v-card-actions>
						<v-switch
							v-model="profile_onsave"
							:label="profile_onsave ? $t('lang.after_save_profile') : $t('lang.after_save_stay')"
							ripple
						></v-switch>
						<!-- <v-btn
                            color='primary'
                            @mouseup.left="toggleAdd()"
                        >
                            {{ isManual ? $t('lang.invite') : $t('lang.manual') }}
                        </v-btn> -->
						<v-spacer></v-spacer>
						<v-btn @mouseup.left="createNewUserDialog = false">{{ $t("lang.cancel") }}</v-btn>
						<v-btn color="success" @mouseup.left="isManual ? addPerson() : inviteUser()">
							{{ isManual ? $t("lang.save") : $t("lang.send") }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</bc-dialog>

			<bc-dialog :value="person_dialog">
				<v-card>
					<v-form ref="form_person">
						<v-container grid-list-form>
							<v-layout v-if="!isManual" row wrap>
								<v-flex xs12 sm6>
									<v-text-field
										v-focus="createNewUserDialog && invite_user.first_name == ''"
										v-model="invite_user.first_name"
										:label="`${$t('lang.first_name')} *`"
										:counter="showCounter(invite_user.first_name, 'user.first_name')"
										:rules="ifValid('person.users.first_name')"
									></v-text-field>
								</v-flex>
								<v-flex xs12 sm6>
									<v-text-field
										v-model="invite_user.last_name"
										:label="`${$t('lang.first_name')} *`"
										:counter="showCounter(invite_user.first_name, 'user.first_name')"
										:rules="ifValid('person.users.first_name')"
									></v-text-field>
								</v-flex>
								<v-flex xs12>
									<bc-phone-input
										ref="user_phone_input"
										:update-object="invite_user"
										input-label="mobile_phone"
										:rules="ifValid('person.users.phone_number')"
									></bc-phone-input>
								</v-flex>
								<v-flex xs12 v-if="isInternalUser() || hasLoginType(['d_acct_mgr', 'distributor'])">
									<bc-autocomplete
										v-model="user.login_type_id"
										:label="`${$t('lang.login_type')} *`"
										:items="returnFilteredLoginTypes"
										item-value="login_type_id"
										item-text="login_type"
										:rules="ifValid('person.users.login_type_id')"
										@change="loginTypeChanged(user.login_type_id)"
									>
										<template v-slot:item="data">
											<template v-if="typeof data.item !== 'object'">
												<v-list-tile-content v-text="data.item"></v-list-tile-content>
											</template>
											<template v-else>
												<v-list-tile-content class="ml-4">
													<v-list-tile-title>{{ $t(`lang.${data.item.login_type}`) }}</v-list-tile-title>
												</v-list-tile-content>
											</template>
										</template>
										<template slot="selection" slot-scope="data">
											{{ $t(`lang.${data.item.login_type}`) }}
										</template>
									</bc-autocomplete>
								</v-flex>
								<v-flex xs12>
									<bc-autocomplete
										v-model="invite_user.company_id"
										:label="`${$t('lang.select_a_company')} *`"
										:items="company_options"
										item-text="company"
										item-value="company_id"
										:rules="ifValid('person.users.company_id')"
									></bc-autocomplete>
								</v-flex>
								<v-flex xs6>
									<v-switch
										v-model="invite_user.owner"
										:label="invite_user.owner == 1 ? $t('lang.is_owner_yes') : $t('lang.is_owner_no')"
										:true-value="1"
										:false-value="0"
										ripple
									></v-switch>
								</v-flex>
							</v-layout>

							<!-- This is the newManual manual form -->
							<v-layout v-if="isManual" row wrap>
								<v-flex :sm6="user_account == 1" :xs12="user_account == 0" pa-0 align-self-start>
									<v-layout row wrap>
										<v-flex xs12 sm6>
											<v-text-field
												v-focus="createNewUserDialog && person.first_name == ''"
												v-model="person.first_name"
												:label="`${$t('lang.first_name')} *`"
												:counter="showCounter(person.first_name, 'person.first_name')"
												:rules="ifValid('person.first_name')"
											></v-text-field>
										</v-flex>
										<v-flex xs12 sm6>
											<v-text-field
												v-model="person.last_name"
												:label="`${$t('lang.last_name')} *`"
												:counter="showCounter(person.last_name, 'person.last_name')"
												:rules="ifValid('person.last_name')"
											></v-text-field>
										</v-flex>
										<v-flex xs12>
											<bc-phone-input
												ref="person_phone_input"
												:update-object="person.entity_phones[0]"
												input-label="mobile_phone"
												:rules="ifValid('person.entity_phones.phone_number')"
											></bc-phone-input>
										</v-flex>
										<v-flex xs12>
											<v-text-field
												v-model="person.entity_emails[0].email_address"
												:label="`${$t('lang.email_address')} *`"
												:counter="showCounter(person.email_address, 'person.email_address')"
												:rules="ifValid('person.entity_emails.email_address')"
											></v-text-field>
										</v-flex>
										<v-flex xs12 sm6>
											<v-text-field
												v-model="person.nick_name"
												:label="$t('lang.nick_name')"
												:counter="showCounter(person.nick_name, 'person.nick_name')"
												:rules="ifValid('person.nick_name')"
											></v-text-field>
										</v-flex>
										<v-flex xs12 sm6>
											<v-text-field
												v-model="person.job_title"
												:label="`${$t('lang.job_title')}`"
												:counter="showCounter(person.job_title, 'person.job_title')"
												:rules="ifValid('person.job_title')"
											></v-text-field>
										</v-flex>
										<v-flex :class="user_account == 1 && $bp.smAndUp ? 'xs12' : 'xs6'">
											<v-switch
												v-model="user_account"
												:label="user_account == 1 ? $t('lang.create_user_account_yes') : $t('lang.create_user_account_no')"
												:true-value="1"
												:false-value="0"
												ripple
												:class="user_account == 1 && $bp.smAndUp ? 'pt-3' : null"
											></v-switch>
										</v-flex>
									</v-layout>
								</v-flex>
								<v-flex xs12 sm6 pa-0 align-self-start v-if="user_account == 1">
									<v-layout row wrap>
										<v-flex xs12>
											<v-text-field
												v-model="user.username"
												:label="`${$t('lang.username')} *`"
												:counter="showCounter(user.username, 'user.username')"
												:rules="ifValid('person.users.username')"
												@change="dbcheckUserNameAvail(user.username)"
											>
												<template slot="append-outer">
													<bc-tooltip>
														<template slot="activator">
															<v-icon :color="availableUserName.exists ? 'error' : 'success'">{{
																availableUserName.exists ? "close" : "check"
															}}</v-icon>
														</template>
														{{ availableUserName.exists ? $t("lang.username_not_avail") : $t("lang.username_avail") }}
													</bc-tooltip>
												</template>
											</v-text-field>
										</v-flex>
										<v-flex xs12>
											<bc-password-input
												v-model="user.password"
												:label="`${$t('lang.password')} *`"
												:counter="showCounter(user.password, 'user.password')"
												:rules="ifValid('person.users.password')"
											></bc-password-input>
										</v-flex>
										<v-flex xs12>
											<bc-password-input
												v-model="confirm_password"
												:label="`${$t('lang.confirm_password')} *`"
												:rules="ifValid('person.users.confirm_password')"
											></bc-password-input>
										</v-flex>
										<v-flex xs12 v-if="isInternalUser() || hasLoginType(['d_acct_mgr', 'distributor'])">
											<bc-autocomplete
												v-model="user.login_type_id"
												:label="`${$t('lang.login_type')} *`"
												:items="login_types"
												item-value="login_type_id"
												item-text="login_type"
												:rules="ifValid('person.users.login_type_id')"
												@change="loginTypeChanged(user.login_type_id)"
											>
												<template v-slot:item="data">
													<template v-if="typeof data.item !== 'object'">
														<v-list-tile-content v-text="data.item"></v-list-tile-content>
													</template>
													<template v-else>
														<v-list-tile-content>
															<v-list-tile-title>{{ $t(`lang.${data.item.login_type}`) }}</v-list-tile-title>
														</v-list-tile-content>
													</template>
												</template>
												<template slot="selection" slot-scope="data">
													{{ $t(`lang.${data.item.login_type}`) }}
												</template>
											</bc-autocomplete>
										</v-flex>
										<v-flex
											xs12
											v-if="
												personHasLoginType(user, [
													'csr',
													'producer',
													'dispatcher',
													'technician',
													'driver',
													'dispenser_mgr',
													'customer',
													'customer_readonly',
													'v_acct_mgr',
													'vendor',
												])
											"
										>
											<bc-autocomplete
												v-model="user.company_id"
												:label="`${$t('lang.select_a_company')} *`"
												:items="
													personHasLoginType(user, [
														'csr',
														'producer',
														'dispatcher',
														'technician',
														'driver',
														'dispenser_mgr',
														'customer',
														'customer_readonly',
													])
														? customer_options
														: vendor_options
												"
												item-text="company"
												item-value="company_id"
												:rules="ifValid('person.users.company_id')"
											></bc-autocomplete>
										</v-flex>
										<v-flex xs12 v-else-if="personHasLoginType(user, ['d_acct_mgr', 'distributor'])">
											<bc-autocomplete
												v-model="user.company_id"
												:label="`${$t('lang.select_a_company')} *`"
												:items="distributor_options"
												item-text="company"
												item-value="company_id"
												:rules="ifValid('person.users.company_id')"
											></bc-autocomplete>
										</v-flex>
										<v-flex
											xs12
											sm6
											v-if="
												hasLoginType([
													'csr',
													'producer',
													'dispatcher',
													'technician',
													'driver',
													'dispenser_mgr',
													'd_acct_mgr',
													'v_acct_mgr',
													'customer',
													'customer_readonly',
													'vendor',
													'distributor',
												])
											"
										>
											<v-switch
												v-model="user.owner"
												:label="user.owner == 1 ? $t('lang.is_owner_yes') : $t('lang.is_owner_no')"
												true-value="1"
												false-value="0"
												ripple
												:class="user_account == 1 && $bp.smAndUp ? 'pt-3' : null"
											></v-switch>
										</v-flex>
									</v-layout>
								</v-flex>
							</v-layout>
						</v-container>
					</v-form>
					<v-form ref="form_person">
						<v-card-title>
							<span class="headline">{{ person.people_id ? $t("lang.edit_person") : $t("lang.add_person") }}</span>
							<v-spacer></v-spacer>
							<bc-btn-dialog-close
								@invoke-method="invokeMethod($event)"
								action="closePersonDialog"
								:dialog-status="person_dialog"
							></bc-btn-dialog-close>
						</v-card-title>
						<v-card-text>
							<v-container grid-list-form>
								<v-layout row wrap>
									<v-flex xs12>
										<v-text-field
											v-focus="person_dialog"
											v-model="person.people_id"
											:label="$t('lang.people_id')"
											:counter="showCounter(person.people_id, 'people.people_id')"
											:rules="ifValid('people.people_id')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.prefix"
											:label="$t('lang.prefix')"
											:counter="showCounter(person.prefix, 'people.prefix')"
											:rules="ifValid('people.prefix')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.first_name"
											:label="$t('lang.first_name')"
											:counter="showCounter(person.first_name, 'people.first_name')"
											:rules="ifValid('people.first_name')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.middle_name"
											:label="$t('lang.middle_name')"
											:counter="showCounter(person.middle_name, 'people.middle_name')"
											:rules="ifValid('people.middle_name')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.last_name"
											:label="$t('lang.last_name')"
											:counter="showCounter(person.last_name, 'people.last_name')"
											:rules="ifValid('people.last_name')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.suffix"
											:label="$t('lang.suffix')"
											:counter="showCounter(person.suffix, 'people.suffix')"
											:rules="ifValid('people.suffix')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.combined_name"
											:label="$t('lang.combined_name')"
											:counter="showCounter(person.combined_name, 'people.combined_name')"
											:rules="ifValid('people.combined_name')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.nick_name"
											:label="$t('lang.nick_name')"
											:counter="showCounter(person.nick_name, 'people.nick_name')"
											:rules="ifValid('people.nick_name')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.job_title"
											:label="$t('lang.job_title')"
											:counter="showCounter(person.job_title, 'people.job_title')"
											:rules="ifValid('people.job_title')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<bc-select
											v-model="person.gender"
											:label="$t('lang.gender')"
											:items="[]"
											item-value="value"
											item-text="text"
											:rules="ifValid('people.gender')"
										></bc-select>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.photo_id"
											:label="$t('lang.photo_id')"
											:counter="showCounter(person.photo_id, 'people.photo_id')"
											:rules="ifValid('people.photo_id')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.photo"
											:label="$t('lang.photo')"
											:counter="showCounter(person.photo, 'people.photo')"
											:rules="ifValid('people.photo')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.entity_phones_id"
											:label="$t('lang.entity_phones_id')"
											:counter="showCounter(person.entity_phones_id, 'people.entity_phones_id')"
											:rules="ifValid('people.entity_phones_id')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.entity_emails_id"
											:label="$t('lang.entity_emails_id')"
											:counter="showCounter(person.entity_emails_id, 'people.entity_emails_id')"
											:rules="ifValid('people.entity_emails_id')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<bc-select
											v-model="person.battery_notify"
											:label="`${$t('lang.battery_notify')} *`"
											:items="[]"
											item-value="value"
											item-text="text"
											:rules="ifValid('people.battery_notify')"
										></bc-select>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.user_time_zone"
											:label="`${$t('lang.user_time_zone')} *`"
											:counter="showCounter(person.user_time_zone, 'people.user_time_zone')"
											:rules="ifValid('people.user_time_zone')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<bc-select
											v-model="person.unit_of_measure"
											:label="`${$t('lang.unit_of_measure')} *`"
											:items="[]"
											item-value="value"
											item-text="text"
											:rules="ifValid('people.unit_of_measure')"
										></bc-select>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.theme"
											:label="`${$t('lang.theme')} *`"
											:counter="showCounter(person.theme, 'people.theme')"
											:rules="ifValid('people.theme')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.notification_method"
											:label="`${$t('lang.notification_method')} *`"
											:counter="showCounter(person.notification_method, 'people.notification_method')"
											:rules="ifValid('people.notification_method')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.language"
											:label="`${$t('lang.language')} *`"
											:counter="showCounter(person.language, 'people.language')"
											:rules="ifValid('people.language')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<v-text-field
											v-model="person.invite_token"
											:label="$t('lang.invite_token')"
											:counter="showCounter(person.invite_token, 'people.invite_token')"
											:rules="ifValid('people.invite_token')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<bc-date-picker
											v-model="person.invite_expires"
											:label="$t('lang.invite_expires')"
											:rules="ifValid('people.invite_expires')"
										></bc-date-picker>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-btn v-if="person.people_id" color="error" @mouseup.left="$refs.delete_people.openDialog()">{{ $t("lang.delete") }}</v-btn>
							<v-spacer></v-spacer>
							<v-btn flat @mouseup.left="closePersonDialog()">{{ $t("lang.cancel") }}</v-btn>
							<v-btn color="success" @click="savePeople">{{ $t("lang.save") }}</v-btn>
						</v-card-actions>
					</v-form>
				</v-card>
			</bc-dialog>
			<delete-confirmation-dialog
				ref="delete_people"
				:heading="$t('lang.delete_person')"
				:message="$t('lang.confirm_delete_message')"
				@onConfirm="deletePeople(person.people_id)"
			></delete-confirmation-dialog>
		</v-container>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import AppConfig from "Constants/AppConfig";
import _ from "lodash";

export default {
	data() {
		return {
			mobile_list: [
				{ title: this.$t("lang.add_new"), action: "openPersonForm" },
				{ title: this.$t("lang.refresh"), action: "dbGetPeople", params: [true] },
			],
			headers: [
				{ text: "", sortable: false, align: "center", width: "60" },
				{ text: this.$t("lang.name"), sortable: false },
				{ text: this.$t("lang.login_type"), sortable: false },
				{ text: this.$t("lang.last_login"), sortable: false, align: "center", width: "200" },
				{ text: this.$t("lang.has_user_account"), sortable: false, align: "center", width: "140" },
			],
			enableEditModal: false,
			user_account: 0,
			person: {},
			filter: {
				search: null,
				login_type: null,
				has_user_account: null,
				company_id: null,
			},
			createNewUserDialog: false,
			person_dialog: false,
			isManual: true,
			profile_onsave: true,
			confirm_password: "",
			invite_user: {
				first_name: "",
				last_name: "",
				gender: "1",
				login_type_id: "",
				company_id: "",
				owner: "0",
				phone_number: null,
			},
			person: {
				first_name: "",
				last_name: "",
				nick_name: "",
				job_title: "",
				gender: "1",
				entity_emails: [
					{
						prime: "1",
						email_address: "",
						email_type: "work",
					},
				],
				entity_phones: [
					{
						prime: "1",
						phone_number: null,
						phone_type: "mobile",
						country_id: "140",
					},
				],
			},
			user: {
				username: "",
				password: "",
				owner: "0",
				login_type_id: "",
				company_id: "",
			},
			availableUserName: {
				exists: true,
			},
			dbGetPeople: _.debounce(this.getPeople, 1500, { maxWait: 1500, leading: true, trailing: false }),
			dbcheckUserNameAvail: _.debounce(this.checkUserNameAvail, 1000, { maxWait: 1500, leading: true, trailing: false }),
			login_types: [],
			loading: true,
		};
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.loading = true;
			_.delay(() => {
				let parsedQuery = JSON.parse(JSON.stringify(to.query));
				store
					.dispatch("fetchPeople", {
						body: parsedQuery,
					})
					.then((data) => {
						if (typeof data !== "undefined" && data.people) {
							vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
							vm.finishLoader();
							vm.loading = false;
						} else {
							next({ name: "dashboard", replace: true });
						}
					});
			}, 500);
		});
	},
	beforeRouteUpdate(to, from, next) {
		this.loading = true;
		let parsedQuery = JSON.parse(JSON.stringify(to.query));
		_.delay(() => {
			this.fetchPeople({
				body: parsedQuery,
			}).then((data) => {
				if (typeof data !== "undefined" && data.people) {
					this.setQuery(parsedQuery, this.filter, this.default_filter);
					this.finishLoader();
					this.loading = false;
					next();
				} else {
					next({ name: "dashboard", replace: true });
				}
			});
		}, 500);
	},
	computed: {
		...mapState({
			default_filter: (state) => state.people.people_filter,
			page: (state) => state.people.page,
			rules_people: (state) => state.people.rules_people,
			rules_person: (state) => state.people.rules_person,
			person_status_options: (state) => state.settings.person_status_options,
			people: (state) => state.people.people,
			company_options: (state) => state.companies.company_options,
			customer_options: (state) => state.customers.customer_options,
			vendor_options: (state) => state.vendors.vendor_options,
			distributor_options: (state) => state.distributors.distributor_options,
		}),
		axiosParams() {
			return this.prepareParams(this.filter, this.default_filter);
		},
		returnFilteredLoginTypes() {
			if (this.current_user.login_group_slug == "account") {
				return this.login_types.filter(
					(login_type) =>
						["customer", "dispatcher", "dispenser_manager", "driver", "producer", "technician"].includes(login_type.slug) ||
						(this.$isSet(login_type.header) && login_type.header.toLowerCase() == "account")
				);
			} else if (this.current_user.login_group_slug == "distributor") {
				(login_type) =>
					["customer", "dispatcher", "dispenser_manager", "driver", "producer", "technician", "distributor", "d_acct_mgr"].includes(
						login_type.slug
					) ||
					(this.$isSet(login_type.header) && ["account", "distributor"].includes(login_type.header.toLowerCase()));
			}
			return this.login_types;
		},
	},
	methods: {
		...mapActions(["fetchPeople", "savePerson", "deletePerson", "fetchCompanies", "fetchCustomers", "fetchVendors", "fetchDistributors"]),
		...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
		async openSearch(force = false) {
			if (this.company_options.length == 0 || force == true) await this.fetchCompanies({ body: { options: 1 } });
		},
		openPersonForm(item = null) {
			if (item != null) {
				this.$router.push({ name: "person", params: { id: item.people_id } });
			} else {
				//this.$router.push({ name: "person" });
				this.createNewUserDialog = true;
			}
		},
		imageLoadError(event) {
			event.target.src = AppConfig.defaultProfilePhoto;
		},
		savePeople() {
			this.validationOn();
			this.$nextTick(() => {
				if (this.validateForm("form_person")) {
					let body = this.prepForm(this.person, this.rules_people);

					this.savePerson({
						body: body,
					}).then((data) => {
						if (data && data.code == "200") {
							if (this.enableEditModal) {
								this.getPeople();
								this.closePersonDialog();
							} else {
								this.$router.push({ name: "person", params: { id: data.people_id } });
							}
						} else {
							//this.toggleModalLoader(false);
						}
					});
				}
			});
		},
		deletePeople(id = null) {
			this.deletePerson({
				id: id,
			}).then((data) => {
				if (data && data.code == "200") {
					this.getPeople();
					this.closePersonDialog();
				} else {
					this.toggleModalLoader(false);
				}
			});
		},
		addPerson() {
			this.validationOn();
			this.$nextTick(() => {
				if (this.validateForm("newUserForm")) {
					if (this.user.username != "") {
						this.person["users"] = this.user;
						delete this.person["users"].slug;
					}

					let body = this.prepForm(this.person, this.rules_person);

					this.savePerson({
						body: body,
					}).then((data) => {
						if (data && data.code == "200") {
							if (this.profile_onsave == false) {
								this.getPeople();
								this.closePersonDialog();
							} else {
								this.$router.push({ name: "person", params: { id: data.person.people_id } });
							}
						} else {
							//this.toggleModalLoader(false);
						}
					});
				}
			});
		},

		closePersonDialog() {
			this.person_dialog = false;
			this.$refs.delete_people.close();
			this.$refs.newUserForm.close();
			this.validationOff();
			this.toggleModalLoader(false);
		},
		getPeople(pg_refresh = false) {
			this.startLoader();
			this.loading = true;

			this.fetchPeople({
				body: JSON.parse(JSON.stringify(this.$route.query)),
			})
				.then((data) => {
					if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
				})
				.finally(() => {
					this.person_dialog = false;
					this.toggleModalLoader(false);
					this.validationOff();
					this.finishLoader(pg_refresh);
					this.loading = false;
				});
		},
		getLoginTypes() {
			this.$store
				.dispatch("fetchLoginType", {
					url: "login_types",
					method: "get",
					body: { by_group: 1 },
				})
				.then((data) => {
					if (typeof data != "undefined") {
						this.login_types = data.app_login_groups;
						// remove all login types except for Customer and Custoemr - Read Only if the current_user is a distributor
						if (this.hasLoginType(["d_acct_mgr", "distributor"])) {
							this.login_types = this.login_types.filter((login_type) => {
								let validLoginTypes = [
									"csr",
									"producer",
									"dispatcher",
									"technician",
									"driver",
									"dispenser_mgr",
									"customer",
									"customer_readonly",
								];
								return !login_type.slug || validLoginTypes.includes(login_type.slug);
							});
						}
					}
				});
		},

		checkUserNameAvail(username) {
			let validateUserName = {
				username: username,
			};
			if (username && this.$refs.newUserForm.validate()) {
				this.$store
					.dispatch("fetchUsers", {
						url: "users/name_check",
						method: "post",
						body: validateUserName,
					})
					.then((data) => {
						if (typeof data !== "undefined") {
							this.availableUserName.exists = data.users.exists;
						}
					});
			} else {
				this.availableUserName.exists = true;
			}
		},
		loginTypeChanged(login_type_id) {
			this.user.slug = this.login_types.find((login_type) => login_type.login_type_id == login_type_id).slug;
			if (
				[
					"employee",
					"customer_support",
					"administrator",
					"developer",
					"csr",
					"producer",
					"dispatcher",
					"technician",
					"driver",
					"dispenser_mgr",
					"customer",
					"customer_readonly",
				].includes(this.user.slug)
			) {
				this.fetchCustomers({ body: { options: 1 } });
			} else if (["v_acct_mgr", "vendor"].includes(this.user.slug)) {
				this.fetchVendors({ body: { options: 1 } });
			} else if (["d_acct_mgr", "distributor"].includes(this.user.slug)) {
				this.fetchDistributors({ body: { options: 1 } });
			}
		},
	},
	mounted() {
		this.getLoginTypes();
	},
};
</script>
